import script from "./PageDisabled.vue?vue&type=script&setup=true&lang=js"
export * from "./PageDisabled.vue?vue&type=script&setup=true&lang=js"

import "./PageDisabled.vue?vue&type=style&index=0&id=3294aa46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3294aa46"]])

export default __exports__